import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const h=l("korea",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19116_3150)">
                <rect
                    width="24"
                    height="16"
                    transform="translate(0 4.5)"
                    fill="#FF4E4E" />
                <path
                    d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                    fill="white" />
                <path
                    d="M3.68018 9.35694L5.90018 6.03027L6.45351 6.40027L4.23351 9.72694L3.68018 9.35694ZM4.51351 9.91027L6.73351 6.58361L7.28684 6.95361L5.06684 10.2803L4.51351 9.91027ZM5.34684 10.4636L7.56684 7.13694L8.12018 7.50694L5.90018 10.8336L5.34684 10.4636Z"
                    fill="black" />
                <path
                    d="M20.32 15.6431L19.3033 17.1698L18.75 16.7998L19.7666 15.2731L20.32 15.6431ZM18.6566 14.5331L18.1033 14.1631L17.0866 15.6898L17.64 16.0598L18.6566 14.5331ZM18.4733 16.6131L19.49 15.0864L18.9366 14.7164L17.92 16.2431L18.4733 16.6131ZM16.9 15.9664L15.8833 17.4931L16.4366 17.8631L17.4533 16.3364L16.9 15.9664ZM17.5466 18.5998L18.1 18.9698L19.1166 17.4431L18.5633 17.0731L17.5466 18.5998ZM17.73 16.5198L16.7133 18.0464L17.2666 18.4164L18.2833 16.8898L17.73 16.5198Z"
                    fill="black" />
                <path
                    d="M8.67334 10.2798C9.90001 8.4431 12.3833 7.94644 14.22 9.16977C16.0567 10.3931 16.5533 12.8798 15.33 14.7164L8.67334 10.2798Z"
                    fill="#CD2E3A" />
                <path
                    d="M8.67308 10.2797C7.44641 12.1164 7.94308 14.5997 9.78308 15.8264C11.6231 17.053 14.1031 16.5564 15.3297 14.7164C15.9431 13.7964 15.6931 12.5564 14.7764 11.943C13.8597 11.3297 12.6164 11.5797 12.0031 12.4964L8.67641 10.2764L8.67308 10.2797Z"
                    fill="#0047A0" />
                <path
                    d="M10.3364 13.3896C11.441 13.3896 12.3364 12.4942 12.3364 11.3896C12.3364 10.2851 11.441 9.38965 10.3364 9.38965C9.23186 9.38965 8.33643 10.2851 8.33643 11.3896C8.33643 12.4942 9.23186 13.3896 10.3364 13.3896Z"
                    fill="#CD2E3A" />
                <path
                    d="M16.9 9.03303L15.8833 7.50637L16.4366 7.13637L17.4533 8.66303L16.9 9.03303ZM19.12 7.55303L18.1033 6.02637L17.55 6.39637L18.5666 7.92303L19.12 7.55303ZM17.0866 9.3097L18.1033 10.8364L18.6566 10.4664L17.64 8.9397L17.0866 9.3097ZM19.3066 7.8297L18.7533 8.1997L19.77 9.72637L20.3233 9.35637L19.3066 7.8297ZM16.7166 6.95303L18.9366 10.2797L19.49 9.9097L17.27 6.58303L16.7166 6.95303Z"
                    fill="black" />
                <path
                    d="M5.53018 16.6131L4.51351 15.0864L5.06684 14.7164L6.08351 16.2431L5.53018 16.6131ZM3.68018 15.6431L5.90018 18.9698L6.45351 18.5998L4.23351 15.2731L3.68018 15.6431ZM5.90018 14.1631L5.34684 14.5331L7.56684 17.8598L8.12018 17.4898L5.90018 14.1631ZM5.71684 16.8898L6.73351 18.4164L7.28684 18.0464L6.27018 16.5198L5.71684 16.8898Z"
                    fill="black" />
            </g>
            <defs>
                <clipPath id="clip0_19116_3150">
                    <rect
                        width="24"
                        height="16"
                        fill="white"
                        transform="translate(0 4.5)" />
                </clipPath>
            </defs>
        </svg>
    `),d=l("korea_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <mask
                id="mask0_19116_3145"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="25">
                <circle
                    cx="12"
                    cy="12.5"
                    r="12"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_19116_3145)">
                <mask
                    id="mask1_19116_3145"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="25">
                    <circle
                        cx="12"
                        cy="12.5"
                        r="12"
                        fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask1_19116_3145)">
                    <g clip-path="url(#clip0_19116_3145)">
                        <path
                            d="M-5.96484 0.499023H30.0352V24.499H-5.96484V0.499023Z"
                            fill="white" />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M-0.46875 7.76855L2.85945 2.77625L3.73529 3.36014L0.407093 8.35245L-0.46875 7.76855ZM0.779326 8.6006L4.10752 3.6083L4.98337 4.19219L1.65517 9.1845L0.779326 8.6006ZM2.0274 9.43265L5.3556 4.44035L6.23144 5.02424L2.90325 10.0165L2.0274 9.43265ZM17.8364 19.9719L21.1646 14.9796L22.0404 15.5635L18.7122 20.5558L17.8364 19.9719ZM19.0844 20.804L22.4126 15.8117L23.2885 16.3956L19.9603 21.3879L19.0844 20.804ZM24.5366 17.2276L21.2084 22.2199L20.3325 21.636L23.6607 16.6437L24.5366 17.2276Z"
                            fill="black" />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M23.0235 20.3516L18.8633 17.5781L19.3499 16.8483L23.5101 19.6218L23.0235 20.3516Z"
                            fill="white" />
                        <path
                            d="M17.0262 15.8262C18.8643 13.069 18.1193 9.34381 15.3621 7.50569C12.6049 5.66758 8.87969 6.41263 7.04158 9.1698C5.20346 11.927 5.94851 15.6522 8.70569 17.4903C11.4629 19.3284 15.1881 18.5834 17.0262 15.8262Z"
                            fill="#CA163A" />
                        <path
                            d="M7.04157 9.1698C6.12299 10.5477 6.49575 12.4115 7.87363 13.3301C9.25151 14.2486 11.1153 13.8759 12.0339 12.498C12.9525 11.1201 14.8163 10.7474 16.1941 11.6659C17.572 12.5845 17.9448 14.4483 17.0262 15.8262C15.189 18.5819 11.4614 19.3275 8.70568 17.4903C5.94993 15.6531 5.20441 11.9256 7.04157 9.1698Z"
                            fill="#0E4896" />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M21.2083 2.77637L24.5365 7.76869L23.6607 8.35258L20.3325 3.36026L21.2083 2.77637ZM19.9603 3.60844L23.2885 8.60072L22.4127 9.18463L19.0844 4.19234L19.9603 3.60844ZM18.7122 4.44049L22.0404 9.43277L21.1645 10.0167L17.8363 5.02438L18.7122 4.44049ZM2.90317 14.9798L6.23137 19.9721L5.35553 20.556L2.02733 15.5637L2.90317 14.9798ZM1.65509 15.8118L4.98329 20.8041L4.10745 21.388L0.779251 16.3957L1.65509 15.8118ZM0.407093 16.6439L3.73529 21.6362L2.85945 22.2201L-0.46875 17.2278L0.407093 16.6439Z"
                            fill="black" />
                        <path
                            d="M2.25928 19.0149L3.50736 18.1829L2.25928 19.0149ZM19.1066 7.78338L20.5644 6.81154L19.1066 7.78338ZM21.8124 5.9795L23.0605 5.14746L21.8124 5.9795Z"
                            fill="black" />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M23.3034 5.5121L22.0553 6.34414L21.5688 5.61427L22.8169 4.78223L23.3034 5.5121ZM20.8073 7.17618L19.3495 8.14802L18.8629 7.41815L20.3207 6.44631L20.8073 7.17618ZM3.75026 18.5476L2.50218 19.3796L2.01562 18.6497L3.2637 17.8177L3.75026 18.5476Z"
                            fill="white" />
                    </g>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_19116_3145">
                    <rect
                        width="36"
                        height="24"
                        fill="white"
                        transform="translate(-5.96484 0.499023)" />
                </clipPath>
            </defs>
        </svg>
    `);export{h as Korea,d as KoreaRounded};
